<template>
    <div id="app">
        <router-view v-if="isRouterAlive && !$route.meta.keepAlive"></router-view>
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive">
            <!-- 这里是会被缓存的视图组件，比如列表A页面 -->
          </router-view>
        </keep-alive>

        <transition name="fade">
            <global-loading :propLOADINGTEXT="LOADINGTEXT"></global-loading>
        </transition>
        <globalToast @toastEnd="setTOASTTEXT('')" :propText="TOASTTEXT" :status="TOASTSTATUS" :propTime="TOASTTIME"></globalToast>
        <transition name="fade">
            <globalAd @close="setGlobalAdShow(false)" v-if="GlobalAdShow" :key="GlobalAdShow"
                      :confirmRoute="GlobalAdConfirmRoute"
                      :cancelRoute="GlobalAdCancelRoute" :period="GlobalAdPeriod"></globalAd>
        </transition>
        <!-- 双十二活动弹窗 -->
      <couponDialog v-if="TESTCHANNEL || showPopWindowStatus"></couponDialog>
    </div>
</template>



<script>
    import {mapState, mapMutations, mapGetters, mapActions} from 'vuex'
    import footerNav from './components/show/footerNav'
    import globalLoading from './components/common/globalLoading.vue'
    import globalToast from './components/common/yxlToast.vue'
    import globalAd from '@/components/promotion/global_ad'
    import couponDialog from "@/components/member/couponDialog"
    export default {
        name: 'app',
        provide(){
            return{
                reload:this.reload
            }
        },
        data(){
            return{
                isRouterAlive:true,
                showAD: false,
                couponDialogData: {
                    propMask: true,
                    title: '',
                    content: '',
                    actions: [],
                },
                test:{}
            }
        },
        components: {
            footerNav,
            globalLoading,
            globalToast,
            globalAd,
            couponDialog
        },
        computed: {
            ...mapState([
                'LOADINGTEXT',
                'TOASTTEXT',
                'TOASTSTATUS',
                'TOASTTIME',
                'userInfo',
                'showPopWindowStatus',
            ]),
            ...mapGetters([
                'GlobalAdConfirmRoute',
                'GlobalAdCancelRoute',
                'GlobalAdPeriod',
                'GlobalAdShow'
            ])
        },
        mounted () {
            const that = this;
            // 禁用双指缩放：
            document.documentElement.addEventListener('touchstart', function (event) {
                if (event.touches.length > 1) {
                    event.preventDefault();
                }
            }, false);
            // 禁用手指双击缩放：
            var lastTouchEnd = 0;
            document.documentElement.addEventListener('touchend', function (event) {
                var now = Date.now();
                if (now - lastTouchEnd <= 300) {
                    event.preventDefault();
                }
                lastTouchEnd = now;
            }, false);
        },
        methods:{
            ...mapMutations(['setGlobalAdShow']),
            ...mapActions(['GET_DISCOUNT_COUPON_STATUS','DISCOUNT_COUPON_RECERIVE','storeSource']),
            reload () {
                this.isRouterAlive = false
                this.$nextTick(function () {
                    this.isRouterAlive = true
                })
            }
        },
        watch:{
        }
    }
</script>


<style lang="scss">
    @import "scss/common";
    .fade-enter,
    .fade-enter-active {
        animation: slideTopIn 1s ease;
    }

    .fade-leave,
    .fade-leave-active {
        animation: slideBottomOut 1s ease;
    }
    @keyframes slideTopIn {
        from {
            transform: translate3d(0, -100%, 0);
        }
        to {
            transform: translate3d(0, 0, 0);
        }
    }

    @keyframes slideBottomOut {
        from {
            transform: translate3d(0, 0, 0);
        }
        to {
            transform: translate3d(0, 200%, 0);

        }
    }

</style>



// WEBPACK FOOTER //
// src/App.vue